export interface ClientSideEnvironment {
  NODE_ENV: 'development' | 'production'
  AUTH0_AUDIENCE_URL: string
  AUTH0_DOMAIN: string
  AUTH0_CLIENT_ID: string
  LOGROCKET_KEY: string
  BILLING_API: string
  DOCUMENT_API: string
  DOCUMENT_API_EXTERNAL: string
  IAM_API: string
  IAM_API_EXTERNAL: string
  IAM_API_INTERNAL: string
  LEGEND_API: string
  MESSAGE_API: string
  NOTIFICATION_API: string
  WORK_DOTNET_API: string
  WORK_DOTNET_API_EXTERNAL: string
  HEAP_APP_ID: string
  LAUNCHDARKLY_CLIENT_SIDE_ID: string
  STRIPE_PK: string
  QUICK_BOOKS_CLIENT_ID: string
  XERO_CLIENT_ID: string
  FRESHBOOKS_API: string
  POSTHOG_KEY: string
}

const env: ClientSideEnvironment =
  typeof window !== 'undefined'
    ? // @ts-ignore
      ((window.__env as ClientSideEnvironment) ?? {})
    : ({} as ClientSideEnvironment)

export default env
